module.exports = __webpack_public_path__ + "static/media/line-half.c80ac400.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/line-half.svg
// module id = 681
// module chunks = 0